import { SpinnerWrapper } from '@repo/ui/components/Icon';
import { P2, P4 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn, FlexRow } from 'styles/layouts';

const FORM_GAP = '24px';
const INPUT_WIDTH = '204px';

export const Form = styled.form`
  display: flex;
  padding: 20px 24px;
  max-width: 708px;
  border-radius: 24px;
  margin: auto;
  background: ${themeStyle.varBackgroundAlt};
  gap: ${FORM_GAP};
  flex-wrap: wrap;
  box-shadow: ${themeStyle.varShadowMedium};
`;

export const CheckboxWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  max-height: 16px;
  align-self: flex-end;
  height: 100%;
  width: 100%;

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  ${QUERIES.tabletAndUp} {
    max-height: 40px;
  }
`;

export const CheckboxLabel = styled(P2)`
  cursor: pointer;
  user-select: none;
  margin-left: 8px;
  width: 100%;
`;

export const InputLabel = styled.label<{ disabled?: boolean }>`
  cursor: pointer;
  user-select: none;
  display: flex;
  flex-direction: column;
  width: 100%;

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export const TextAreaLabel = styled(InputLabel)`
  max-width: 432px;

  ${QUERIES.tabletAndUp} {
    width: calc(100% - ${FORM_GAP} - ${INPUT_WIDTH});
  }
`;

export const RequiredFields = styled(FlexColumn)`
  width: 100%;
  gap: 24px;

  ${QUERIES.tabletAndUp} {
    width: ${INPUT_WIDTH};
  }
`;

export const FieldsGrid = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr;
  width: 100%;

  ${QUERIES.tabletAndUp} {
    grid-template-columns: repeat(auto-fit, 204px);
  }
`;

export const CTAWrapper = styled.div`
  width: 100%;

  ${QUERIES.tabletAndUp} {
    width: 204px;
    margin-left: auto;
  }
`;

export const CenteredSpinnerWrapper = styled(SpinnerWrapper)`
  width: 50px;
  margin: auto;
  padding: 40px 0;
`;

export const SwitchWrapper = styled(FlexRow)`
  width: 100%;
  gap: 8px;
`;

export const TextAreaWrapper = styled.div<{
  disabled?: boolean;
  error?: boolean;
}>`
  height: 100%;

  // Needed only for stretchy text area
  > div {
    height: 100%;

     textarea {
      color: ${({ disabled }) =>
        disabled ? themeStyle.varInkMedium : themeStyle.varInkMain};
      pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
      transition: color ${themeStyle.transitionDuration};
      caret-color: ${({ error }) => (error ? themeStyle.alertRed : 'auto')};

      &::placeholder {
        color: ${({ error }) =>
          error ? themeStyle.alertRed : themeStyle.varInkMedium};

      &:not(:focus) {
        color: ${themeStyle.varInkMedium};
      }
    }
  }
`;

export const TextAreaError = styled(P4)`
  color: ${themeStyle.alertRed};
  margin-top: 3px;
`;
